<div class="card card-custom gutter-b card-stretch new-coustom-class">
    <div class="card-body" style="min-height: 70vh" *ngIf="cardBodyMessage === 'mainCard'">
        <app-reports-list></app-reports-list>
    </div>
    <div class="card-body" style="" *ngIf="cardBodyMessage === 'viewReport'">
        <app-view-report [currentReport]="currentReport" [reportName]="reportName"></app-view-report>
    </div>
    <div class="card-body" style="min-height: 113vh" *ngIf="cardBodyMessage === 'viewSubscription'">
        <app-report-subscription [reportName]="reportName" [reportId]="reportId"
            [supportedFileTypes]="supportedFileTypes"></app-report-subscription>
    </div>
</div>